import React, { useState, useEffect } from 'react';
import { portfolioData } from '../../data/portfolioData';

export const MainMenu = ({ onStartGame, onShowLevels, onToggleSound, soundEnabled }) => {
  const [showAbout, setShowAbout] = useState(false);
  const [animationPhase, setAnimationPhase] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationPhase(prev => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const blockStyle = { width: '40px', height: '40px', border: '3px solid #000', background: '#f5c116', boxShadow: '2px 2px 0 #000' };

  return (
    <div className="min-h-screen retro-ui relative overflow-hidden" style={{ background: 'linear-gradient(to top, #66c1ff 0%, #93e0ff 50%, #a5fdff 100%)' }} data-testid="main-menu">
      <div className="absolute inset-x-0 top-0 h-24 flex items-end justify-center gap-3 pointer-events-none select-none">
        {[...Array(7)].map((_, i) => (
          <span key={i} className="mario-block" style={{ ...blockStyle, marginTop: i % 2 === 0 ? 0 : 12 }} />
        ))}
      </div>

      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-white/85"
            style={{
              width: 60 + (i % 3) * 10,
              height: 22 + (i % 2) * 10,
              left: `${10 + i * 12}%`,
              top: `${5 + (i * 11) % 20}%`,
              opacity: 0.85,
              animation: 'float 5s ease-in-out infinite',
              animationDelay: `${i * 0.2}s`
            }}
          />
        ))}
      </div>

      <div className="relative z-10 mx-auto text-center pt-20 main-menu-mobile" style={{ maxWidth: 720 }}>
        <h1 className="text-3xl md:text-7xl text-red-600 drop-shadow-2xl" style={{ fontFamily: 'Press Start 2P, sans-serif' }}>
          ★ AKHIL'S MUSHROOM QUEST ★
        </h1>

        <div className="mt-6 md:mt-8 flex flex-col gap-3 max-w-sm mx-auto menu-buttons">
          <button onClick={onStartGame} className="retro-btn">
            🍄 START GAME
          </button>
          <button onClick={onShowLevels} className="retro-btn bg-[#ffcc00] text-black hover:bg-[#ffd94d]">
            🏆 SELECT LEVEL
          </button>
          <button onClick={() => setShowAbout(true)} className="retro-btn bg-[#4cbb17] hover:bg-[#61d233]">
            ℹ️ ABOUT
          </button>
          <button onClick={onToggleSound} className="retro-btn bg-[#d60000] hover:bg-[#ff3b3b]">
            {soundEnabled ? <>🔊 SOUND ON</> : <>🔇 SOUND OFF</>}
          </button>
        </div>

        <div className="mt-10 flex items-center justify-center gap-3">
          <a href={portfolioData.personal.github} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-xl bg-black text-white flex items-center justify-center text-lg">🐙</a>
          <a href={portfolioData.personal.linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-xl bg-blue-700 text-white flex items-center justify-center text-lg">🔗</a>
          <a href={`mailto:${portfolioData.personal.email}`} className="w-10 h-10 rounded-xl bg-red-500 text-white flex items-center justify-center text-lg">✉️</a>
        </div>

        <p className="mt-6 text-sm text-white/80">Use arrow keys or A/D to move, W/Up/Space to jump.</p>
      </div>

      {showAbout && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowAbout(false)}>
          <div className="bg-white rounded-2xl border-4 border-black p-6 max-w-md w-full" onClick={e => e.stopPropagation()}>
            <h2 className="text-2xl font-bold text-black">About Akhil’s Mario World</h2>
            <p className="mt-2 text-sm text-slate-800">This game is a portfolio adventure in retro style, built with React.</p>
            <button onClick={() => setShowAbout(false)} className="mt-4 retro-btn">CLOSE</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default MainMenu;
